export default "__VITE_ASSET__BWCj02oL__"